<script setup lang="ts">

import { useBackButton } from "@app/Components/Utilities";

useBackButton();

</script>

<template>

    <div class="bg-white dark:bg-gray-850 tracking-wider text-sm lg:text-base
                 w-full h-full overflow-y-auto flex flex-col pb-12">

        <div class="flex justify-center items-center my-6">
            <strong class="text-lg font-bold">Servicing</strong>
        </div>     

        <div class="flex flex-col w-full gap-3 px-4 lg:px-6">
        
            <h1>
                Regular servicing of a vehicle is crucial for several reasons:
            </h1>

            <div class="pl-2 lg:pl-4 flex flex-col w-full gap-3 dark:text-gray-300">
            
                <p>
                    <span class="dark:text-white">Safety:</span> Ensuring your vehicle is in good working condition 
                    reduces the risk of accidents.
                </p>

                <p>
                    <span class="dark:text-white">Reliability:</span> Routine servicing helps prevent unexpected breakdowns. 
                    Regular oil changes, fluid top-ups, and part replacements keep your vehicle running 
                    smoothly and reduce the chances of unexpected failures.
                </p>        

                <p>
                    <span class="dark:text-white">Performance:</span> A well-maintained vehicle performs better. 
                    It delivers better fuel efficiency, smoother acceleration, and 
                    overall improved driving experience.
                </p>

                <p>
                    <span class="dark:text-white">Resale Value:</span> If you ever decide to sell or trade in your vehicle, 
                    a well-documented service history significantly increases its resale value.
                </p>        

                <p>
                    <span class="dark:text-white">Warranty Requirements:</span> Many vehicle warranties require regular 
                    servicing to remain valid. Neglecting maintenance could void your warranty.
                </p>

            </div>

            <p>
                Ultimately, regular servicing is an investment in the safety, reliability, and 
                longevity of your vehicle. It's a small price to pay compared to the potential 
                consequences of neglecting maintenance.
            </p>  

        </div>

    </div>   
    
</template>
